import { companySorts } from './sorts';

export const KEY_ALIAS = {
  kantones: 'canton',
  zip: 'zip',
  cities: 'city',
  rate: 'rate',
  software: 'soft',
  communicationPreferences: 'comm',
  accountingBasis: 'basis',
  specialisation: 'spec',
  industries: 'industry',
  specialOffer: 'offer',
  languages: 'lang',
  members: 'member',
  isTaxRepresentation: 'tax',
};

export const filterObject = {
  sort: {
    [companySorts.NAME.value]: 'abc',
  },
  canton: {
    Alle: 'all',
    Zürich: 'zh',
    Bern: 'be',
    Luzern: 'lu',
    Uri: 'ur',
    Schwyz: 'sz',
    Obwalden: 'ow',
    Nidwalden: 'nw',
    Glarus: 'gl',
    Zug: 'zg',
    Solothurn: 'so',
    'Basel-Stadt': 'bs',
    'Basel-Landschaft': 'bl',
    Schaffhausen: 'sh',
    'Appenzell Ausserrhoden': 'ar',
    'Appenzell Innerrhoden': 'ai',
    'St. Gallen': 'sg',
    Aargau: 'ag',
    Thurgau: 'tg',
    Graubünden: 'gr',
    Freiburg: 'fr',
    Wallis: 'vs',
  },
  zip: {
    '14**': '14',
    '15**': '15',
    '16**': '16',
    '17**': '17',
    '18**': '18',
    '19**': '19',
    '23**': '23',
    '25**': '25',
    '26**': '26',
    '27**': '27',
    '28**': '28',
    '30**': '30',
    '31**': '31',
    '32**': '32',
    '33**': '33',
    '34**': '34',
    '35**': '35',
    '36**': '36',
    '37**': '37',
    '38**': '38',
    '39**': '39',
    '40**': '40',
    '41**': '41',
    '42**': '42',
    '43**': '43',
    '44**': '44',
    '45**': '45',
    '46**': '46',
    '47**': '47',
    '48**': '48',
    '49**': '49',
    '50**': '50',
    '51**': '51',
    '52**': '52',
    '53**': '53',
    '54**': '54',
    '55**': '55',
    '56**': '56',
    '57**': '57',
    '60**': '60',
    '61**': '61',
    '62**': '62',
    '63**': '63',
    '64**': '64',
    '65**': '65',
    '70**': '70',
    '71**': '71',
    '72**': '72',
    '73**': '73',
    '74**': '74',
    '75**': '75',
    '76**': '76',
    '77**': '77',
    '80**': '80',
    '81**': '81',
    '82**': '82',
    '83**': '83',
    '84**': '84',
    '85**': '85',
    '86**': '86',
    '87**': '87',
    '88**': '88',
    '89**': '89',
    '90**': '90',
    '91**': '91',
    '92**': '92',
    '93**': '93',
    '94**': '94',
    '95**': '95',
    '96**': '96',
  },
  rate: {
    secretary: 'secretary',
    accountant: 'accountant',
    auditor: 'auditor',
    expert: 'expert',
  },
  soft: {
    Alle: 'all',
    Bexio: 'bexio',
    Banana: 'banana',
    'Office Maker': 'officemaker',
    LoopsFinanz: 'loopsfinanz',
    Klara: 'klara',
    Abacus: 'abacus',
    Sage: 'sage',
    Comatic: 'comatic',
    CashCtrl: 'cashctrl',
  },
  comm: {
    online: 'online',
    betreuungVorOrt: 'offline',
  },
  basis: { 'Accounting basics': 'TRUE' },
  spec: {
    Alle: 'all',
    'MWST-Fragen': 'vat',
    Lohnbuchhaltung: 'payroll',
    'Personalwesen/Arbeitsrecht': 'hr',
    Vorsorgeberatung: 'pension',
    Wirtschaftsprüfung: 'audit',
    Revision: 'revision',
    'Juristische Beratung': 'legal',
    Unternehmensberatung: 'business',
    'Steuerberatung Schweiz': 'steuern',
    'Steuerberatung International': 'tax',
    Erbschaftsberatung: 'inheritance',
    Nachfolgeplanung: 'succession',
    Immobilienverwaltung: 're',
    'Domizil-Services': 'domicile',
    Firmengründung: 'foundation',
    Vermögensverwaltung: 'asset',
    Finanzplanung: 'fin',
    Businesspläne: 'bp',
  },
  industry: {
    Gastgewerbe: 'horeca',
    Finanzen: 'fin',
    Information: 'it',
    Landwirtschaft: 'agro',
    Kunst: 'art',
    Grundbesitz: 're',
    Verkehr: 'logistics',
    Autogewerbe: 'auto',
    Versorgung: 'supply',
    Sonstige: 'other',
  },
  offer: { 'Special offer': 'TRUE' },
  lang: {
    All: 'all',
    German: 'ge',
    English: 'en',
    French: 'fr',
    Italian: 'it',
    Russian: 'ru',
    Spanish: 'sp',
    Portuguese: 'pt',
    Arabian: 'ar',
    'Rhaeto-Romanic': 'rm',
    Dutch: 'nl',
    Bulgarian: 'bg',
    Finnish: 'fi',
    Greek: 'el',
    Albanian: 'sq',
    'Romanian ': 'ro',
    Rumänisch: 'ro',
    Slovak: 'sk',
    Slowakisch: 'sk',
    Turkish: 'tr',
    Türkisch: 'tr',
    Hebrew: 'he',
    Hebräisch: 'he',
    Macedonian: 'mk',
    Mazedonisch: 'mk',
    'Serbo-Croatian': 'sh',
    Serbokroatisch: 'sh',
    Chinese: 'zh',
    Chinesisch: 'zh',
    Polish: 'pl',
    Polnisch: 'pl',
    Hungarian: 'hu',
    Ungarisch: 'hu',
    Norwegian: 'no',
    Norwegisch: 'no',
    Croatian: 'hr',
    Kroatisch: 'hr',
    Serbian: 'sr',
    Serbisch: 'sr',
    Danish: 'da',
    Dänisch: 'da',
    Swedish: 'sv',
    Schwedisch: 'sv',
    Czech: 'cs',
    Tschechisch: 'cs',
    Tamil: 'ta',
    Bosnian: 'bs',
    Deutsch: 'ge',
    Englisch: 'en',
    Französisch: 'fr',
    Italienisch: 'it',
    Russisch: 'ru',
    Holländisch: 'nl',
    Spanisch: 'sp',
    Portugiesisch: 'pt',
    Arabisch: 'ar',
    Rätoromanisch: 'rm',
    Bulgarisch: 'bg',
    Finnisch: 'fi',
    Griechisch: 'el',
    Albanisch: 'sq',
    Rumänisch: 'ro',
    Slowakisch: 'sk',
    Türkisch: 'tr',
    Hebräisch: 'he',
    Mazedonisch: 'mk',
    Serbokroatisch: 'sh',
    Chinesisch: 'zh',
    Polnisch: 'pl',
    Ungarisch: 'hu',
    Norwegisch: 'no',
    Kroatisch: 'hr',
    Serbisch: 'sr',
    Dänisch: 'da',
    Schwedisch: 'sv',
    Tschechisch: 'cs',
    Bosnisch: 'bs',
  },
  member: {
    Alle: 'all',
    'Treuhand Suisse': 'ts',
    'Veb.ch': 'veb',
    EXPERTsuisse: 'es',
  },
  tax: { 'Tax representation': 'TRUE' },
};
